/** @format */

import { Box, IconButton, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/button';

export default function SelectTicketTypeModal({ open, onClose, onSelectFleet, onSelectTolling }) {
  const { t } = useTranslation();

  return (
    <Dialog
      className="ticket-modal-dialog"
      fullWidth
      maxWidth="sm"
      open={open}
      PaperProps={{
        style: {
          backgroundColor: '#fff',
          borderRadius: 10
        }
      }}
      onClose={onClose}
      aria-labelledby="select-ticket-type-dialog"
    >
      <DialogActions>
        <IconButton onClick={onClose}>
          <CloseIcon style={{ color: '#000' }} />
        </IconButton>
      </DialogActions>
      <DialogContent>
        <div className="create-ticket-body">
          <Typography className="create-ticket-title create-ticket-title-request-type-selection">
            {t('Tickets.selectTicketType')}
          </Typography>
          <Box className="create-ticket-box">
            <Typography className="create-ticket-description-request-type-selection">
              {t('Tickets.selectTicketTypeDescription')}
            </Typography>
            <div className="create-ticket-btns-step-1 create-ticket-btns-request-type-selection">
              <Button borderOnly onClick={onSelectFleet}>
                VDO Fleet
              </Button>
              <Button borderOnly onClick={onSelectTolling}>
                Tolling
              </Button>
            </div>
          </Box>
        </div>
      </DialogContent>
    </Dialog>
  );
}
